import React, {lazy} from 'react';
import {Route} from 'react-router-dom';


import * as newsletterConstants from '../newsletterConstants';

import RootRoutes from '../../../roots/RootRoutes';

const NewsletterSubscribedPage = lazy(() => import('./NewsletterSubscribedPage'));


function NewsletterPages() {

    return (
        <RootRoutes>

            <Route
                element={<NewsletterSubscribedPage/>}
                exact={true}
                path={newsletterConstants.NAV_NEWSLETTER_SUBSCRIBED}
            />

        </RootRoutes>
    );
}


export default NewsletterPages;
